'use client';

import { Button } from 'lighthouse';

import { ATTRIBUTE_FILTER_COPY } from '@/utilities/attributeFilters/constants';

import { ActiveAttributeFilterChipsProps } from '../../models';

export const ActiveAttributeFilterChips = ({ activeCount, onClearAll, className = '' }: ActiveAttributeFilterChipsProps) => {
    if (!activeCount) {
        return null;
    }

    return (
        <div className={`flex justify-end ${className}`.trim()}>
            <Button variant='text' color='primary' className='min-w-0 px-1 py-0.5 text-xs' onClick={onClearAll}>
                {ATTRIBUTE_FILTER_COPY.clearAll}
            </Button>
        </div>
    );
};
